export default __webpack_public_path__ + "static/media/facebook.8a0f51e2.svg";